// NCE Carousel
const createNceCarouselSlick = function($list) {
    var next = $list.data('next');
    var prev = $list.data('prev');
    var uid = $list.data('id');

    var slidesToShow = nce_carousel_slidesToShow();

    if ($(window).width() < 1170) {
        slidesToShow = 1;
    }

    // Random-Funktionalität bei Slider
    if ($list.parents('.ttgNCESliderCouselRandomExceptFirst').length > 0) {
        $list.find('.nce-carousel-item:not(:first)').shuffle();
    } else if ($list.parents('.ttgNCESliderCouselRandom').length > 0) {
        $list.find('.nce-carousel-item').shuffle();
    }

    if ($list.find('.nce-carousel-item').length > slidesToShow) {
        $list.on('init', function(event, slick, currentSlide) {
            $list.find('.slick-slide a').attr('tabindex', -1);
            $list.find('.slick-slide button').attr('tabindex', -1);
            $list.find('.slick-slide.slick-active a').removeAttr('tabindex');
            $list.find('.slick-slide.slick-active button').removeAttr('tabindex');
            color_indicators(1, $("#ttgNCECarousel" + uid + " .slider-indicators"), slidesToShow);

            $list.next().show();
        });

        $list.slick({
            accessibility: false,
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            variableWidth: true,
            swipeToSlide: true,
            infinite: false,
            dots: false,
            slide: '.nce-carousel-item',
            prevArrow: '<button class="slick-prev" type="button"><span class="fa-regular fa-chevron-left" aria-hidden="true"></span><span class="sr-only">' + prev + '</span></button>',
            nextArrow: '<button class="slick-next" type="button"><span class="fa-regular fa-chevron-right" aria-hidden="true"></span><span class="sr-only">' + next + '</span></button>',
            responsive: [
                {
                    breakpoint: 1170,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        }).on('afterChange', function(event, slick, currentSlide) {
            $list.find('.slick-slide a').attr('tabindex', -1);
            $list.find('.slick-slide button').attr('tabindex', -1);
            $list.find('.slick-slide.slick-active a').removeAttr('tabindex');
            $list.find('.slick-slide.slick-active button').removeAttr('tabindex');
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            color_indicators(nextSlide + 1, $("#ttgNCECarousel" + uid + " .slider-indicators"), slidesToShow);
        });
    } else {
        $("#ttgNCECarousel" + uid + " .slider-indicators").hide();
    }
};

const nce_carousel_slidesToShow = function() {
    return Math.floor(($(window).width() - 35) / 391);
};

$('.ttg-nce-carousel').each(function() {
    createNceCarouselSlick($(this));
});

// Öffnungszeiten bei Gastro + POI Carousel Items laden, sofern die Checkbox "Öffnungszeiten anzeigen" im NCE aktiviert wurde
$.each($('.carousel-oeffnungszeiten'), function() {

    var $carouselOeffnungszeitenItem = $(this);
    var sourceId = $carouselOeffnungszeitenItem.data('sourceid');
    var sysLanguageUid = $('.ttgDataWrapperOnlyNeededForJS').data('actlanguagesysuid');
    var item = {};
    item.ObjectID = sourceId;
    item.ObjectType = $carouselOeffnungszeitenItem.data('type');
    item.MetaExperience = 'webarchitektur-meta';

    $.ajax({
        type: "POST",
        url: '/index.php?id=' + rootPage + '&type=1890&L=' + sysLanguageUid,
        data: "object=" + JSON.stringify(item) + '&style=carousel',
        beforeSend: function() {
            $('.carousel-oeffnungszeiten[data-sourceid="' + sourceId + '"]').html('<span class="fa-solid fa-circle-notch fa-spin" aria-hidden="true"></span>');
        },
        success: function(result) {
            if (result === 'no-time-intervals') {
                $('.carousel-oeffnungszeiten[data-sourceid="' + sourceId + '"]').remove();
            } else {
                $('.carousel-oeffnungszeiten[data-sourceid="' + sourceId + '"]').find('span').remove();
                $('.carousel-oeffnungszeiten[data-sourceid="' + sourceId + '"]').html(result);
            }
        },
        error: function() {
            $('.carousel-oeffnungszeiten[data-sourceid="' + sourceId + '"]').find('span').remove();
        },
        complete: function(result) {}
    });

});

// Auslastung bei POI Carousel Items laden, sofern die Checkbox "Auslastung anzeigen" im NCE aktiviert wurde
$.each($('.carousel-auslastung'), function() {

    var $carouselAuslastungItem = $(this);
    var sourceId = $carouselAuslastungItem.data('sourceid');
    var lang = $('.ttgDataWrapperOnlyNeededForJS').data('actlanguage');
    var sysLanguageUid = $('.ttgDataWrapperOnlyNeededForJS').data('actlanguagesysuid');
    if (lang == "cz") {
        lang = "cs";
    }

    $.ajax({
        type: "POST",
        url: '/index.php?id=' + rootPage + '&type=1950&L=' + sysLanguageUid,
        data: {
            lang: lang,
            sysLanguageUid: sysLanguageUid,
            L: sysLanguageUid,
            sourceid: sourceId,
            tdType: $carouselAuslastungItem.data('type'),
        },
        beforeSend: function() {
            $('.carousel-auslastung[data-sourceid="' + sourceId + '"]').html('<span class="fa-solid fa-circle-notch fa-spin" aria-hidden="true"></span>');
            $('.carousel-auslastung[data-sourceid="' + sourceId + '"]').attr("aria-busy", true);
        },
        success: function(result) {
            $('.carousel-auslastung[data-sourceid="' + sourceId + '"]').find('span').remove();
            $('.carousel-auslastung[data-sourceid="' + sourceId + '"]').html(result);
        },
        error: function() {
            $('.carousel-auslastung[data-sourceid="' + sourceId + '"]').find('span').remove();
        },
        complete: function(result) {
            $('.carousel-auslastung[data-sourceid="' + sourceId + '"]').attr("aria-busy", false);
        }
    });

});

// Carousel Event Next Termine asynchron laden
if ($('.ttg-carousel-tourdata-event').length > 0) {
    $.each($('.ttg-carousel-tourdata-termin-ort'), function() {
        var $item = $(this);
        var sourceId = $item.data('sourceid');

        var lang = $('.ttgDataWrapperOnlyNeededForJS').data('actlanguage');
        var slugLang = lang;
        var sysLanguageUid = $('.ttgDataWrapperOnlyNeededForJS').data('actlanguagesysuid');
        if (lang == "cz") {
            lang = "cs";
        }

        // slugLang muss mitübergegben werden, damit im AjaxResponse View auch die richtige Sprache verwendet wird
        if (slugLang === 'cs') {
            slugLang = 'cz';
        }
        if (slugLang === 'de') {
            slugLang = '';
        } else {
            slugLang = '/' + slugLang.trim();
        }

        $.ajax({
            type: "GET",
            url: slugLang + '/?type=2040&L=' + sysLanguageUid,
            data: {
                lang: lang,
                sourceId: sourceId,
            },
            beforeSend: function() {
                $item.html('<span class="fa-solid fa-circle-notch fa-spin" aria-hidden="true"></span>');
            },
            success: function(result) {

            },
            error: function() {

            },
            complete: function(result) {
                $item.html(result.responseText);
            }
        });
    });
}

